const utils = {
  namespaced: true,
  state: {
    isLoading: {
      status: false,
      transparent: false
    },
    snackbar: [],
    coords: {
      latitude: -23.5647577,
      longitude: -46.651849500000026
    },
    isRetrievingCoords: false
  },
  mutations: {
    SET_IS_LOADING (state, payload) {
      state.isLoading.status = payload.status
      state.isLoading.transparent = (payload.transparent ? payload.transparent : false)
    },
    SHOW_SNACKBAR (state, payload) {
      state.snackbar.push(payload)
    },
    REMOVE_SNACKBAR (state) {
      state.snackbar.shift()
    },
    EMPTY_SNACKBAR (state) {
      state.snackbar = state.snackbar.filter((snackbar) => {
        return snackbar.persistent === true
      })
    },
    SET_COORDS (state, payload) {
      state.coords.latitude = payload.coords.latitude
      state.coords.longitude = payload.coords.longitude
    },
    SET_RETRIEVING_COORDS (state, payload) {
      state.isRetrievingCoords = payload
    }
  },
  actions: {
    showLoading ({ commit }, payload) {
      if (payload !== undefined) {
        commit('SET_IS_LOADING', { status: true, transparent: payload.transparent })
      } else {
        commit('SET_IS_LOADING', { status: true })
      }
    },
    hideLoading ({ commit }, payload) {
      commit('SET_IS_LOADING', { status: false })
    },
    showSnackbar ({ commit }, payload) {
      commit('SHOW_SNACKBAR', payload)
    },
    hideSnackbar ({ commit }) {
      commit('REMOVE_SNACKBAR')
    },
    emptySnackbar ({ commit }) {
      commit('EMPTY_SNACKBAR')
    },
    setRetrievingCoords ({ commit }, payload) {
      commit('SET_RETRIEVING_COORDS', payload)
    },
    setCoords ({ commit, dispatch }, payload) {
      if (payload === false) {
        const coordsDefault = {
          coords: {
            latitude: -23.5647577,
            longitude: -46.651849500000026
          }
        }
        commit('SET_COORDS', coordsDefault)
      } else {
        commit('SET_COORDS', payload)
      }
    },
    getCoords ({ commit, dispatch }) {
      const coordsDefault = {
        coords: {
          latitude: -23.5647577,
          longitude: -46.651849500000026
        }
      }
      if (navigator.geolocation) {
        commit('SET_RETRIEVING_COORDS', true)
        dispatch('utils/showLoading', {}, { root: true })
        navigator.geolocation.getCurrentPosition((position) => {
          const payload = {
            coords: {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            }
          }
          commit('SET_COORDS', payload)
          dispatch('utils/hideLoading', {}, { root: true })
          commit('SET_RETRIEVING_COORDS', false)
        }, () => {
          commit('SET_COORDS', coordsDefault)
          dispatch('utils/hideLoading', {}, { root: true })
          commit('SET_RETRIEVING_COORDS', false)
        })
      } else {
        commit('SET_COORDS', coordsDefault)
      }
    }
  },
  getters: {
    isLoading (state) {
      return state.isLoading
    },
    snackbar (state) {
      return state.snackbar
    },
    coords (state) {
      return state.coords
    },
    isRetrievingCoords (state) {
      return state.isRetrievingCoords
    }
  }
}

export default utils



// WEBPACK FOOTER //
// ./src/vuex/modules/utils.js